// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"61cc1dfd","413":"cc7f718f","572":"702dccad"}[chunkId] + ".chunk.js";
};